import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Header
      appName: "Mood of the World",
      // Mood display
      analyzing: "Analyzing global mood...",
      // Panels
      history: "History",
      regional: "Regional Moods",
      keyTopics: "Key Topics",
      prediction: "AI Prediction",
      social: "Social Sentiment",
      stats: "Statistics",
      eventImpact: "Event Impact",
      forecast: "24h Forecast",
      // Stats
      headlines: "Headlines",
      sources: "Sources",
      intensity: "Intensity",
      status: "Status",
      live: "Live",
      impact: "Impact",
      // Actions
      refresh: "Refresh",
      share: "Share",
      compare: "Compare",
      exportReport: "Export Report",
      // Tour
      tourTitle1: "Global Mood Orb",
      tourContent1: "This visualizes the current emotional state of the world. The color and animation reflect the mood intensity.",
      tourTitle2: "Mood Adjective",
      tourContent2: "A single word captures global sentiment, determined by AI analysis of 100+ news sources.",
      tourTitle3: "Regional Moods",
      tourContent3: "See how different parts of the world are feeling based on local news sources.",
      tourTitle4: "Key Topics",
      tourContent4: "The Word Cloud shows significant topics driving the current mood.",
      tourTitle5: "Mood History",
      tourContent5: "Track how the mood has changed over time. Click to see the full journey.",
      previous: "Previous",
      next: "Next",
      finish: "Finish",
      pause: "Pause",
      // Emotions
      anger: "anger",
      fear: "fear",
      sadness: "sadness",
      calm: "calm",
      hope: "hope",
      energy: "energy",
      confusion: "confusion",
      neutral: "neutral",
      // Regions
      northAmerica: "North America",
      europe: "Europe",
      asia: "Asia",
      southAmerica: "South America",
      africa: "Africa",
      oceania: "Oceania",
      middleEast: "Middle East",
      // Modals
      moodJourney: "Mood Journey",
      playJourney: "Play Journey",
      latest: "Latest",
      older: "Older",
      recent: "Recent",
      shareTitle: "Share Current Mood",
      copyLink: "Copy Link",
      copied: "Copied!",
      compareMoods: "Compare Moods",
      selectDates: "Select two dates to compare",
      // Subscription
      subscribe: "Subscribe",
      emailDigest: "Email Digest",
      smsAlerts: "SMS Alerts",
      pushNotifications: "Push Notifications",
      daily: "Daily",
      weekly: "Weekly",
      moodChange: "On mood change",
      // SMS
      phoneNumber: "Phone Number",
      enterPhone: "Enter your phone number",
      subscribeToSMS: "Subscribe to SMS Alerts",
      smsSuccess: "SMS subscription successful!",
      // Settings
      settings: "Settings",
      language: "Language",
      theme: "Theme",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      sound: "Sound",
      soundOn: "Sound On",
      soundOff: "Sound Off",
      // Keyboard shortcuts
      keyboardShortcuts: "Keyboard Shortcuts",
      refreshAnalysis: "Refresh mood analysis",
      toggleTheme: "Toggle dark/light mode",
      toggleSound: "Toggle ambient sound",
      openHistory: "Open mood history",
      compareDates: "Compare dates",
      showShortcuts: "Show keyboard shortcuts",
      startTour: "Start guided tour",
      // Pull to refresh
      pullToRefresh: "Pull to refresh",
      releaseToRefresh: "Release to refresh",
      // Alerts
      alerts: "Alerts",
      noAlerts: "No alerts",
      // Social
      positive: "positive",
      negative: "negative",
      // Prediction
      stable: "Stable",
      rising: "Rising",
      falling: "Falling",
      volatile: "Volatile",
      confidence: "confidence",
      // 7-Day Forecast Modal
      sevenDayForecast: "7-Day Mood Forecast",
      forecastMethodology: "Forecast Methodology",
      keyDrivers: "Key Drivers",
      riskFactors: "Risk Factors",
      aiPrediction: "AI Prediction",
    }
  },
  es: {
    translation: {
      appName: "Estado de Ánimo del Mundo",
      analyzing: "Analizando el estado de ánimo global...",
      history: "Historial",
      regional: "Estados Regionales",
      keyTopics: "Temas Clave",
      prediction: "Predicción IA",
      social: "Sentimiento Social",
      stats: "Estadísticas",
      eventImpact: "Impacto de Eventos",
      forecast: "Pronóstico 24h",
      headlines: "Titulares",
      sources: "Fuentes",
      intensity: "Intensidad",
      status: "Estado",
      live: "En Vivo",
      impact: "Impacto",
      refresh: "Actualizar",
      share: "Compartir",
      compare: "Comparar",
      exportReport: "Exportar Informe",
      tourTitle1: "Orbe del Estado de Ánimo Global",
      tourContent1: "Esto visualiza el estado emocional actual del mundo. El color y la animación reflejan la intensidad.",
      tourTitle2: "Adjetivo del Estado de Ánimo",
      tourContent2: "Una sola palabra captura el sentimiento global, determinado por análisis de IA de más de 100 fuentes.",
      tourTitle3: "Estados Regionales",
      tourContent3: "Vea cómo se sienten diferentes partes del mundo basándose en fuentes locales.",
      tourTitle4: "Temas Clave",
      tourContent4: "La nube de palabras muestra los temas significativos que impulsan el estado de ánimo actual.",
      tourTitle5: "Historial del Estado de Ánimo",
      tourContent5: "Rastree cómo ha cambiado el estado de ánimo con el tiempo.",
      previous: "Anterior",
      next: "Siguiente",
      finish: "Finalizar",
      pause: "Pausar",
      anger: "ira",
      fear: "miedo",
      sadness: "tristeza",
      calm: "calma",
      hope: "esperanza",
      energy: "energía",
      confusion: "confusión",
      neutral: "neutral",
      northAmerica: "América del Norte",
      europe: "Europa",
      asia: "Asia",
      southAmerica: "América del Sur",
      africa: "África",
      oceania: "Oceanía",
      middleEast: "Medio Oriente",
      moodJourney: "Viaje del Estado de Ánimo",
      playJourney: "Reproducir Viaje",
      latest: "Más Reciente",
      older: "Más Antiguo",
      recent: "Reciente",
      shareTitle: "Compartir Estado Actual",
      copyLink: "Copiar Enlace",
      copied: "¡Copiado!",
      compareMoods: "Comparar Estados",
      selectDates: "Seleccione dos fechas para comparar",
      subscribe: "Suscribirse",
      emailDigest: "Resumen por Email",
      smsAlerts: "Alertas SMS",
      pushNotifications: "Notificaciones Push",
      daily: "Diario",
      weekly: "Semanal",
      moodChange: "Al cambiar el estado",
      phoneNumber: "Número de Teléfono",
      enterPhone: "Ingrese su número de teléfono",
      subscribeToSMS: "Suscribirse a Alertas SMS",
      smsSuccess: "¡Suscripción SMS exitosa!",
      settings: "Configuración",
      language: "Idioma",
      theme: "Tema",
      darkMode: "Modo Oscuro",
      lightMode: "Modo Claro",
      sound: "Sonido",
      soundOn: "Sonido Activado",
      soundOff: "Sonido Desactivado",
      keyboardShortcuts: "Atajos de Teclado",
      refreshAnalysis: "Actualizar análisis",
      toggleTheme: "Cambiar tema",
      toggleSound: "Cambiar sonido",
      openHistory: "Abrir historial",
      compareDates: "Comparar fechas",
      showShortcuts: "Mostrar atajos",
      startTour: "Iniciar tour",
      pullToRefresh: "Tire para actualizar",
      releaseToRefresh: "Suelte para actualizar",
      alerts: "Alertas",
      noAlerts: "Sin alertas",
      positive: "positivo",
      negative: "negativo",
      stable: "Estable",
      rising: "Subiendo",
      falling: "Bajando",
      volatile: "Volátil",
      confidence: "confianza",
    }
  },
  fr: {
    translation: {
      appName: "Humeur du Monde",
      analyzing: "Analyse de l'humeur mondiale...",
      history: "Historique",
      regional: "Humeurs Régionales",
      keyTopics: "Sujets Clés",
      prediction: "Prédiction IA",
      social: "Sentiment Social",
      stats: "Statistiques",
      eventImpact: "Impact des Événements",
      headlines: "Titres",
      sources: "Sources",
      intensity: "Intensité",
      status: "Statut",
      live: "En Direct",
      impact: "Impact",
      refresh: "Actualiser",
      share: "Partager",
      compare: "Comparer",
      exportReport: "Exporter Rapport",
      tourTitle1: "Orbe d'Humeur Globale",
      tourContent1: "Ceci visualise l'état émotionnel actuel du monde. La couleur et l'animation reflètent l'intensité.",
      tourTitle2: "Adjectif d'Humeur",
      tourContent2: "Un seul mot capture le sentiment global, déterminé par l'analyse IA de plus de 100 sources.",
      tourTitle3: "Humeurs Régionales",
      tourContent3: "Voyez comment différentes parties du monde se sentent basé sur les sources locales.",
      tourTitle4: "Sujets Clés",
      tourContent4: "Le nuage de mots montre les sujets significatifs qui influencent l'humeur actuelle.",
      tourTitle5: "Historique d'Humeur",
      tourContent5: "Suivez comment l'humeur a changé au fil du temps.",
      previous: "Précédent",
      next: "Suivant",
      finish: "Terminer",
      pause: "Pause",
      anger: "colère",
      fear: "peur",
      sadness: "tristesse",
      calm: "calme",
      hope: "espoir",
      energy: "énergie",
      confusion: "confusion",
      neutral: "neutre",
      northAmerica: "Amérique du Nord",
      europe: "Europe",
      asia: "Asie",
      southAmerica: "Amérique du Sud",
      africa: "Afrique",
      oceania: "Océanie",
      middleEast: "Moyen-Orient",
      moodJourney: "Voyage d'Humeur",
      playJourney: "Lancer le Voyage",
      latest: "Plus Récent",
      older: "Plus Ancien",
      recent: "Récent",
      shareTitle: "Partager l'Humeur Actuelle",
      copyLink: "Copier le Lien",
      copied: "Copié!",
      compareMoods: "Comparer les Humeurs",
      selectDates: "Sélectionnez deux dates à comparer",
      subscribe: "S'abonner",
      emailDigest: "Résumé Email",
      smsAlerts: "Alertes SMS",
      pushNotifications: "Notifications Push",
      daily: "Quotidien",
      weekly: "Hebdomadaire",
      moodChange: "Au changement d'humeur",
      phoneNumber: "Numéro de Téléphone",
      enterPhone: "Entrez votre numéro",
      subscribeToSMS: "S'abonner aux Alertes SMS",
      smsSuccess: "Abonnement SMS réussi!",
      settings: "Paramètres",
      language: "Langue",
      theme: "Thème",
      darkMode: "Mode Sombre",
      lightMode: "Mode Clair",
      sound: "Son",
      soundOn: "Son Activé",
      soundOff: "Son Désactivé",
      keyboardShortcuts: "Raccourcis Clavier",
      refreshAnalysis: "Actualiser l'analyse",
      toggleTheme: "Changer le thème",
      toggleSound: "Changer le son",
      openHistory: "Ouvrir l'historique",
      compareDates: "Comparer les dates",
      showShortcuts: "Afficher les raccourcis",
      startTour: "Démarrer le tour",
      pullToRefresh: "Tirez pour actualiser",
      releaseToRefresh: "Relâchez pour actualiser",
      alerts: "Alertes",
      noAlerts: "Pas d'alertes",
      positive: "positif",
      negative: "négatif",
      stable: "Stable",
      rising: "En hausse",
      falling: "En baisse",
      volatile: "Volatile",
      confidence: "confiance",
    }
  },
  de: {
    translation: {
      appName: "Stimmung der Welt",
      analyzing: "Analysiere globale Stimmung...",
      history: "Verlauf",
      regional: "Regionale Stimmungen",
      keyTopics: "Schlüsselthemen",
      prediction: "KI-Vorhersage",
      social: "Soziale Stimmung",
      stats: "Statistiken",
      eventImpact: "Ereignis-Auswirkungen",
      headlines: "Schlagzeilen",
      sources: "Quellen",
      intensity: "Intensität",
      status: "Status",
      live: "Live",
      impact: "Auswirkung",
      refresh: "Aktualisieren",
      share: "Teilen",
      compare: "Vergleichen",
      exportReport: "Bericht Exportieren",
      tourTitle1: "Globaler Stimmungsball",
      tourContent1: "Dies visualisiert den aktuellen emotionalen Zustand der Welt. Farbe und Animation spiegeln die Intensität wider.",
      tourTitle2: "Stimmungs-Adjektiv",
      tourContent2: "Ein einzelnes Wort erfasst die globale Stimmung, ermittelt durch KI-Analyse von über 100 Quellen.",
      tourTitle3: "Regionale Stimmungen",
      tourContent3: "Sehen Sie, wie sich verschiedene Teile der Welt fühlen, basierend auf lokalen Quellen.",
      tourTitle4: "Schlüsselthemen",
      tourContent4: "Die Wortwolke zeigt bedeutende Themen, die die aktuelle Stimmung beeinflussen.",
      tourTitle5: "Stimmungsverlauf",
      tourContent5: "Verfolgen Sie, wie sich die Stimmung im Laufe der Zeit verändert hat.",
      previous: "Zurück",
      next: "Weiter",
      finish: "Fertig",
      pause: "Pause",
      anger: "Wut",
      fear: "Angst",
      sadness: "Traurigkeit",
      calm: "Ruhe",
      hope: "Hoffnung",
      energy: "Energie",
      confusion: "Verwirrung",
      neutral: "Neutral",
      northAmerica: "Nordamerika",
      europe: "Europa",
      asia: "Asien",
      southAmerica: "Südamerika",
      africa: "Afrika",
      oceania: "Ozeanien",
      middleEast: "Naher Osten",
      moodJourney: "Stimmungsreise",
      playJourney: "Reise Abspielen",
      latest: "Neueste",
      older: "Älter",
      recent: "Aktuell",
      shareTitle: "Aktuelle Stimmung Teilen",
      copyLink: "Link Kopieren",
      copied: "Kopiert!",
      compareMoods: "Stimmungen Vergleichen",
      selectDates: "Wählen Sie zwei Daten zum Vergleichen",
      subscribe: "Abonnieren",
      emailDigest: "Email-Zusammenfassung",
      smsAlerts: "SMS-Benachrichtigungen",
      pushNotifications: "Push-Benachrichtigungen",
      daily: "Täglich",
      weekly: "Wöchentlich",
      moodChange: "Bei Stimmungswechsel",
      phoneNumber: "Telefonnummer",
      enterPhone: "Geben Sie Ihre Telefonnummer ein",
      subscribeToSMS: "SMS-Alerts Abonnieren",
      smsSuccess: "SMS-Abonnement erfolgreich!",
      settings: "Einstellungen",
      language: "Sprache",
      theme: "Thema",
      darkMode: "Dunkelmodus",
      lightMode: "Hellmodus",
      sound: "Ton",
      soundOn: "Ton An",
      soundOff: "Ton Aus",
      keyboardShortcuts: "Tastenkürzel",
      refreshAnalysis: "Analyse aktualisieren",
      toggleTheme: "Thema wechseln",
      toggleSound: "Ton umschalten",
      openHistory: "Verlauf öffnen",
      compareDates: "Daten vergleichen",
      showShortcuts: "Kürzel anzeigen",
      startTour: "Tour starten",
      pullToRefresh: "Ziehen zum Aktualisieren",
      releaseToRefresh: "Loslassen zum Aktualisieren",
      alerts: "Warnungen",
      noAlerts: "Keine Warnungen",
      positive: "positiv",
      negative: "negativ",
      stable: "Stabil",
      rising: "Steigend",
      falling: "Fallend",
      volatile: "Volatil",
      confidence: "Vertrauen",
    }
  },
  zh: {
    translation: {
      appName: "世界情绪",
      analyzing: "正在分析全球情绪...",
      history: "历史",
      regional: "区域情绪",
      keyTopics: "关键话题",
      prediction: "AI预测",
      social: "社交情绪",
      stats: "统计",
      eventImpact: "事件影响",
      headlines: "头条",
      sources: "来源",
      intensity: "强度",
      status: "状态",
      live: "实时",
      impact: "影响",
      refresh: "刷新",
      share: "分享",
      compare: "比较",
      exportReport: "导出报告",
      tourTitle1: "全球情绪球",
      tourContent1: "这可视化了世界当前的情感状态。颜色和动画反映了情绪强度。",
      tourTitle2: "情绪形容词",
      tourContent2: "一个词捕捉全球情绪，由AI分析100多个新闻来源确定。",
      tourTitle3: "区域情绪",
      tourContent3: "查看世界不同地区的感受，基于当地新闻来源。",
      tourTitle4: "关键话题",
      tourContent4: "词云显示影响当前情绪的重要话题。",
      tourTitle5: "情绪历史",
      tourContent5: "追踪情绪随时间的变化。",
      previous: "上一步",
      next: "下一步",
      finish: "完成",
      pause: "暂停",
      anger: "愤怒",
      fear: "恐惧",
      sadness: "悲伤",
      calm: "平静",
      hope: "希望",
      energy: "能量",
      confusion: "困惑",
      neutral: "中性",
      northAmerica: "北美",
      europe: "欧洲",
      asia: "亚洲",
      southAmerica: "南美",
      africa: "非洲",
      oceania: "大洋洲",
      middleEast: "中东",
      moodJourney: "情绪之旅",
      playJourney: "播放旅程",
      latest: "最新",
      older: "较早",
      recent: "最近",
      shareTitle: "分享当前情绪",
      copyLink: "复制链接",
      copied: "已复制！",
      compareMoods: "比较情绪",
      selectDates: "选择两个日期进行比较",
      subscribe: "订阅",
      emailDigest: "邮件摘要",
      smsAlerts: "短信提醒",
      pushNotifications: "推送通知",
      daily: "每日",
      weekly: "每周",
      moodChange: "情绪变化时",
      phoneNumber: "电话号码",
      enterPhone: "输入您的电话号码",
      subscribeToSMS: "订阅短信提醒",
      smsSuccess: "短信订阅成功！",
      settings: "设置",
      language: "语言",
      theme: "主题",
      darkMode: "深色模式",
      lightMode: "浅色模式",
      sound: "声音",
      soundOn: "声音开启",
      soundOff: "声音关闭",
      keyboardShortcuts: "键盘快捷键",
      refreshAnalysis: "刷新分析",
      toggleTheme: "切换主题",
      toggleSound: "切换声音",
      openHistory: "打开历史",
      compareDates: "比较日期",
      showShortcuts: "显示快捷键",
      startTour: "开始导览",
      pullToRefresh: "下拉刷新",
      releaseToRefresh: "释放刷新",
      alerts: "警报",
      noAlerts: "无警报",
      positive: "积极",
      negative: "消极",
      stable: "稳定",
      rising: "上升",
      falling: "下降",
      volatile: "波动",
      confidence: "置信度",
    }
  },
  ar: {
    translation: {
      appName: "مزاج العالم",
      analyzing: "جاري تحليل المزاج العالمي...",
      history: "التاريخ",
      regional: "المزاج الإقليمي",
      keyTopics: "المواضيع الرئيسية",
      prediction: "توقعات الذكاء الاصطناعي",
      social: "المشاعر الاجتماعية",
      stats: "الإحصائيات",
      eventImpact: "تأثير الأحداث",
      headlines: "العناوين",
      sources: "المصادر",
      intensity: "الكثافة",
      status: "الحالة",
      live: "مباشر",
      impact: "التأثير",
      refresh: "تحديث",
      share: "مشاركة",
      compare: "مقارنة",
      exportReport: "تصدير التقرير",
      tourTitle1: "كرة المزاج العالمي",
      tourContent1: "هذا يُظهر الحالة العاطفية الحالية للعالم. اللون والحركة تعكس كثافة المزاج.",
      tourTitle2: "صفة المزاج",
      tourContent2: "كلمة واحدة تلتقط المشاعر العالمية، يحددها تحليل الذكاء الاصطناعي لأكثر من 100 مصدر.",
      tourTitle3: "المزاج الإقليمي",
      tourContent3: "شاهد كيف تشعر مناطق مختلفة من العالم بناءً على المصادر المحلية.",
      tourTitle4: "المواضيع الرئيسية",
      tourContent4: "سحابة الكلمات تظهر المواضيع المهمة التي تؤثر على المزاج الحالي.",
      tourTitle5: "تاريخ المزاج",
      tourContent5: "تتبع كيف تغير المزاج مع مرور الوقت.",
      previous: "السابق",
      next: "التالي",
      finish: "إنهاء",
      pause: "إيقاف مؤقت",
      anger: "غضب",
      fear: "خوف",
      sadness: "حزن",
      calm: "هدوء",
      hope: "أمل",
      energy: "طاقة",
      confusion: "ارتباك",
      neutral: "محايد",
      northAmerica: "أمريكا الشمالية",
      europe: "أوروبا",
      asia: "آسيا",
      southAmerica: "أمريكا الجنوبية",
      africa: "أفريقيا",
      oceania: "أوقيانوسيا",
      middleEast: "الشرق الأوسط",
      moodJourney: "رحلة المزاج",
      playJourney: "تشغيل الرحلة",
      latest: "الأحدث",
      older: "الأقدم",
      recent: "الأخير",
      shareTitle: "مشاركة المزاج الحالي",
      copyLink: "نسخ الرابط",
      copied: "تم النسخ!",
      compareMoods: "مقارنة الأمزجة",
      selectDates: "اختر تاريخين للمقارنة",
      subscribe: "اشتراك",
      emailDigest: "ملخص البريد الإلكتروني",
      smsAlerts: "تنبيهات الرسائل",
      pushNotifications: "إشعارات الدفع",
      daily: "يومي",
      weekly: "أسبوعي",
      moodChange: "عند تغير المزاج",
      phoneNumber: "رقم الهاتف",
      enterPhone: "أدخل رقم هاتفك",
      subscribeToSMS: "الاشتراك في تنبيهات الرسائل",
      smsSuccess: "تم الاشتراك في الرسائل بنجاح!",
      settings: "الإعدادات",
      language: "اللغة",
      theme: "المظهر",
      darkMode: "الوضع الداكن",
      lightMode: "الوضع الفاتح",
      sound: "الصوت",
      soundOn: "الصوت مفعل",
      soundOff: "الصوت معطل",
      keyboardShortcuts: "اختصارات لوحة المفاتيح",
      refreshAnalysis: "تحديث التحليل",
      toggleTheme: "تبديل المظهر",
      toggleSound: "تبديل الصوت",
      openHistory: "فتح التاريخ",
      compareDates: "مقارنة التواريخ",
      showShortcuts: "إظهار الاختصارات",
      startTour: "بدء الجولة",
      pullToRefresh: "اسحب للتحديث",
      releaseToRefresh: "حرر للتحديث",
      alerts: "التنبيهات",
      noAlerts: "لا توجد تنبيهات",
      positive: "إيجابي",
      negative: "سلبي",
      stable: "مستقر",
      rising: "صاعد",
      falling: "هابط",
      volatile: "متقلب",
      confidence: "الثقة",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
